import { EDITOR_KEYS } from "@/other/constants/EditorKeys";
import { shouldShowAsyncDialog } from "@/bryntum-lib/editors/AsyncTaskMessageEditor/SwivuAsyncMessagePopup";
import { getApiErrorMessage } from "@/integrations";

/** True when a promote generate call returned an accepted async-task shape. */
export function isAcceptedAsyncGenerateResponse(response: {
  status?: number;
  data?: { id?: unknown };
} | null | undefined): boolean {
  return (
    response?.status === 202 ||
    response?.status === 200 ||
    (response?.data != null && typeof response.data.id !== "undefined")
  );
}

export function openMarketingAsyncDialog(
  editorHandler: { openEditor: (...args: unknown[]) => void } | null | undefined,
  recordKey: string,
) {
  if (!editorHandler || !shouldShowAsyncDialog(recordKey)) return;
  editorHandler.openEditor(
    EDITOR_KEYS.asyncTaskMessageEditor,
    null,
    { record: recordKey },
    { useExisting: true, by: "recordType" },
  );
}

/** Prefer API body fields; also works when `data` is a raw async-task result payload. */
export function messageFromApiPayload(data: unknown, fallback: string): string {
  return getApiErrorMessage({ response: { data } }, fallback);
}

export function asyncTaskIdFromResponse(response: {
  data?: { id?: unknown };
} | null | undefined): number | undefined {
  const raw = response?.data?.id;
  const id = typeof raw === "number" ? raw : Number(raw);
  return Number.isFinite(id) ? id : undefined;
}
